export default "__VITE_ASSET__Db4aZw8h__"